import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';

export function useRevenues(params = {}) {
  return useQuery({
    queryKey: ['finance', 'revenues', params],
    queryFn: async () => {
      const { data } = await api.get('/finance/revenues', { params });
      return data;
    },
    staleTime: 15_000
  });
}

export function useRevenue(id) {
  return useQuery({
    queryKey: ['finance', 'revenue', id],
    queryFn: async () => {
      const { data } = await api.get(`/finance/revenues/${id}`);
      return data?.revenue || data?.data || data;
    },
    enabled: !!id
  });
}

export function useCreateRevenue() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (body) => api.post('/finance/revenues', body).then((r) => r.data),
    successMessage: 'تم تسجيل الإيراد',
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['finance', 'revenues'] });
      qc.invalidateQueries({ queryKey: ['finance', 'stats'] });
      qc.invalidateQueries({ queryKey: ['cashbox'] });
    }
  });
}
